var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/modules/es.symbol.iterator.js